import { API } from "@infra/api";
import type { IShifts } from "@ports/shifts/IShifts";
import { makeShiftsUseCases } from "@app/shifts";

const shiftsApi: IShifts = {
	createMany: (shifts) => API.Data.Shifts.create.many(shifts),
	updateMany: (shifts) => API.Data.Shifts.update.many(shifts),
};

export const shiftsUseCases = makeShiftsUseCases({ shiftsApi });
